import Stepper from "@keyvaluesystems/react-stepper";
import React, { useEffect, useState } from "react";
import StepForm1 from "./form/step1";
import StepNoDocLoanForm1 from "./form/NoDocLoan/step1";
import StepForm2 from "./form/step2";
import StepForm3 from "./form/step3";
import StepFormComplete from "./form/complete";
import MoneyHeroBanner from "../../assets/images/money_hero_banner.svg";
import MoneyHeroBannerSp from "../../assets/images/money_hero_banner_sp.svg";
import NoDocLoanBanner from "../../assets/images/no-doc-loan/no-doc-loan-bg.jpeg";
import NoDocLoanBannerSp from "../../assets/images/no-doc-loan/no-doc-loan-bg-sp.jpeg";
import { createGuid } from "../../utils/common";
import { actionGetConfig } from "../../store/application/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

function MoneyHero({ page = 'money-hero' }) {

    const [stepData, setStepData] = useState([
        {
            stepLabel: "基本資料",
            completed: false,
        },
        {
            stepLabel: "工作資料",
            completed: false,
        },
        {
            stepLabel: "住址資料",
            completed: false,
        },
        {
            stepLabel: "申請完成",
            completed: false,
        },
    ]);
    const [formData, setFormData] = useState({});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    // no-doc-loan은 1스텝 안에서 기존 2/3스텝까지 처리하므로 전용 분기가 필요합니다.
    const isNoDocLoan = page === 'no-doc-loan';

    const styles = {
        LineSeparator: () => ({
            backgroundColor: "#FD9F40",
        }),
        ActiveNode: () => ({
            backgroundColor: "#FD9F40",
        }),
        CompletedNode: () => ({
            backgroundColor: "#FD9F40",
        }),
        LabelTitle: () => ({
            color: '#FFF'
        }),
        ActiveLabelTitle: () => ({
            color: '#FD9F40'
        }),
    };

    const [currentStep, setCurrentStep] = useState(0);
    const [sessionId, setSessionId] = useState();
    const [banner, setBanner] = useState(MoneyHeroBanner);
    const [bannerSp, setBannerSp] = useState(MoneyHeroBannerSp);
    const [homeTitle, setHomeTitle] = useState('申請Cashing Pro網上私人貸款');

    useEffect(() => {
        // add meta tag
        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex';
        document.getElementsByTagName('head')[0].prepend(meta);

        // Change title, description
        if(isNoDocLoan){
            document.title = 'Gen Z限定｜立即申請一口價即批$5000 - Cashing Pro優尚信貸';
            const metaDescription = document.querySelector("meta[name='description']");
            if (metaDescription) {
                metaDescription.setAttribute("content", "Gen Z想借錢？Cashing Pro一口價即批$5000，貸款免入息免文件，靈活閃批！");
            }
            setBanner(NoDocLoanBanner);
            setBannerSp(NoDocLoanBannerSp);
            setHomeTitle('申請Gen Z一口價$5000貸款');
        }
        onRedirectHomePage();
    }, []);

    const onRedirectHomePage = async () => {
        const response = await dispatch(actionGetConfig('MONEY_HERO_REDIRECT_HOMEPAGE'));
        if (response?.sts_code === 0) {
            if (response?.content === '1') {
                window.location.href = process.env.REACT_APP_HOME_URL;
            }
        }
    };

    const handleStepClick = (step, stepIndex) => { }

    const onCompleted = (payload) => {
        if (payload.status) {
            // no-doc-loan은 submit 완료 후 완료 화면으로 바로 이동하기 위해 nextStepIndex를 넘깁니다.
            const nextStep = payload.nextStepIndex ?? currentStep + 1;
            setCurrentStep(nextStep);
            let updateStepData = [...stepData];
            updateStepData[currentStep]['completed'] = payload.status;
            setStepData(updateStepData);
            const allActive = document.querySelectorAll('.node-active');
            if (allActive.length > 0) {
                allActive.forEach((el, _) => {
                    el.classList.remove('node-active')
                });
            }
            const nodeEl = document.getElementById(`${nextStep}-node`);
            if (nodeEl) {
                const activeNode = nodeEl.querySelector('.node');
                if (activeNode) {
                    activeNode.classList.add('node-active');
                }
            }
            setFormData(prev => {
                return { ...prev, ...payload.data }
            })
        }
    }

    useEffect(() => {
        const nodeEl = document.getElementById(`0-node`);
        if (nodeEl) {
            const activeNode = nodeEl.querySelector('.node');
            if (activeNode) {
                activeNode.classList.add('node-active');
            }
        }
        let session_id = localStorage.getItem('session_id');
        if (!session_id) {
            session_id = createGuid();
            localStorage.setItem('session_id', session_id);
        }
        setSessionId(session_id);
    }, []);

    return (
        <>
            {currentStep === 0 && <div className="mb-6">
                <img className="lg:block max-md:hidden w-full mt-[-20px]" src={banner} alt="" />
                <img className="sm:block md:hidden w-full" src={bannerSp} alt="" />
            </div>}
            <div className="bg-white p-5 lg:p-12 mt-4">
                <div className="flex justify-center flex-col lg:space-x-20 space-y-4">
                    <div className="flex flex-col justify-center items-center space-y-5">
                        <h1 className="text-2xl text-[#493A64] font-bold">{homeTitle}</h1>
                        {currentStep !== 3 && <p className="text-gray1"><span className="text-primary">抱歉本公司恕不接受</span>破產申請中、破產中人士、信貸報告有撇帳紀錄之人士的貸款申請。</p>}
                    </div>
                    {isNoDocLoan ? (
                        // no-doc-loan은 상단 Stepper를 숨기고 현재 단계 컴포넌트만 렌더링합니다.
                        getContent(currentStep, onCompleted, sessionId, formData, page)
                    ) : (
                        <Stepper
                            steps={stepData}
                            currentStepIndex={currentStep}
                            orientation="horizontal"
                            labelPosition="top"
                            onStepClick={handleStepClick}
                            styles={styles}
                            renderNode={(step, stepIndex) => <span key={stepIndex}></span>}
                            stepContent={(step, stepIndex) => getContent(stepIndex, onCompleted, sessionId, formData, page)}
                        />
                    )}
                </div>
            </div>
        </>
    )
}


function getContent(stepIndex, onCompleted, sessionId, formData, page) {
    return (
        <>
            {stepIndex === 0 && (page === 'no-doc-loan' ? <StepNoDocLoanForm1 sessionId={sessionId} onCompleted={onCompleted} /> : <StepForm1 sessionId={sessionId} onCompleted={onCompleted} />)}
            {stepIndex === 1 && <StepForm2 sessionId={sessionId} formData={formData} onCompleted={onCompleted} />}
            {stepIndex === 2 && <StepForm3 sessionId={sessionId} formData={formData} onCompleted={onCompleted} page={page} />}
            {stepIndex === 3 && <StepFormComplete page={page} />}
        </>
    )
}

export default MoneyHero;
